exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Inviter__Modal__aMLXe p {\n    padding-top: 0;\n    margin-top: 0;\n    padding-bottom: 0;\n    margin-bottom: 0;\n    text-align: left;\n}\n\n.Inviter__Modal__aMLXe h3 {\n    text-align: left;\n    margin-bottom: 0.5rem;\n}\n\n.Inviter__Modal__aMLXe form {\n    width: 100%;\n}\n\n\np.Inviter__error__2gRf0 {\n    color: #f34672;\n    padding-top: 1rem;\n}\n\ninput.Inviter__error__2gRf0 {\n    border-color: #f34672;\n    color: #68323f;\n}", ""]);

// exports
exports.locals = {
	"Modal": "Inviter__Modal__aMLXe",
	"error": "Inviter__error__2gRf0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/containers/Company/Inviter/Inviter.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/containers/Company/Inviter/Inviter.css
// module chunks = 0